/**
 * @Author:      jiang.weiwei
 * @DateTime:    2017-12-12 17:19:48
 * @Description: 新建用户
 */
"use strict";
angular.module("backArticleModule", []).
controller("backArticleCtrl", ["$scope", "$modalInstance", function($scope, $modalInstance) {
    initStatus();
	initData();
    function initStatus() {
        $scope.status = {
        	
        };
        $scope.data = {
        	backReason : ''
        }
    }
    function initData(){
    	requestData();
    }
    $scope.confirm = function() {
        $modalInstance.close($scope.data.backReason);
    };
    $scope.cancel = function() {
        $modalInstance.dismiss();
    };
    function requestData(){
    }
    
}]);